import styled from 'styled-components';
import { Card, Button } from '@mantine/core';

export const QRContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
`;

export const QRCodeCanvas = styled.img`
  max-width: 300px;
  max-height: 300px;
  width: 100%;
  height: auto;
  border-radius: 8px;
`;

export const PaymentForm = styled(Card)`
  margin-bottom: 24px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
`;

export const PaymentInfo = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #29860c;
`;

export const DownloadButton = styled(Button)`
  background: linear-gradient(135deg, #29860c 0%, #1e5f08 100%);
  border: none;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #1e5f08 0%, #0d3a04 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(41, 134, 12, 0.3);
  }
`;

export const PaymentCard = styled(Card)`
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
`;

export const QRCodeWrapper = styled.div`
  position: relative;
  display: inline-block;
  
  &::before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    background: linear-gradient(45deg, #29860c, #1e5f08, #29860c);
    border-radius: 16px;
    z-index: -1;
    opacity: 0.1;
  }
`;

export const PaymentMethodCard = styled(Card)<{ $isSelected: boolean }>`
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid ${props => props.$isSelected ? '#29860c' : '#e0e0e0'};
  background: ${props => props.$isSelected ? '#f0f8f0' : '#ffffff'};

  &:hover {
    border-color: #29860c;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(41, 134, 12, 0.2);
  }
`;

export const AmountDisplay = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #29860c;
  text-align: center;
  margin: 16px 0;
  padding: 12px;
  background: linear-gradient(135deg, #f0f8f0 0%, #e8f5e8 100%);
  border-radius: 8px;
  border: 1px solid #c8e6c8;
`;

export const PaymentDetails = styled.div`
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-top: 16px;
  border-left: 4px solid #29860c;
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #29860c;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Responsive design
export const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    ${QRContainer} {
      padding: 16px;
    }
    
    ${QRCodeCanvas} {
      max-width: 250px;
    }
    
    ${AmountDisplay} {
      font-size: 20px;
    }
  }

  @media (max-width: 480px) {
    ${QRContainer} {
      padding: 12px;
    }
    
    ${QRCodeCanvas} {
      max-width: 200px;
    }
    
    ${AmountDisplay} {
      font-size: 18px;
    }
  }
`;

